<template>
    <div v-if="show" class="main-box loading-content">
        <div class="skype-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <h3>{{text}}</h3>
        </div>
        
    </div>
</template>

<script>
    export default {
        name: 'loading',
        props:{
            show:Boolean,
            text:{
                type:String,
                default:''
            }
        },
        data() {
            return {
            
            }
        },
    }
</script>

<style scoped lang="less">
.loading-content{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    background: rgba(0,0,0,.5);
    .skype-loader {
        width: 7rem;
        // max-width: 120px;
        position: relative;
        left: 50%;
        top: 50%;
        margin-left: -27px;
        margin-top: -20px;
        text-align: center;
        div{
            display: inline-block;
            width: 4px;
            height: 100%;
            border-radius: 4px;
            background: #279FCF;
            margin:0 3px;
            -webkit-animation: load 1.04s ease infinite;
            animation:load 1.04s ease infinite;
            -ms-animation:load 1.04s ease infinite;
            -moz-animation:load 1.04s ease infinite;
            -o-animation:load 1.04s ease infinite;
        }
        div:nth-child(2){
            -webkit-animation-delay:0.13s;
            animation-delay:0.13s;-moz-animation-delay:0.13s;-o-animation-delay:0.13s;-ms-animation-delay:0.13s;
        }
        div:nth-child(3){
            -webkit-animation-delay:0.26s;
            animation-delay:0.26;-moz-animation-delay:0.26s;-o-animation-delay:0.26s;-ms-animation-delay:0.26s;
        }
        div:nth-child(4){
            -webkit-animation-delay:0.39s;
            animation-delay:0.39s;-moz-animation-delay:0.39s;-o-animation-delay:0.39s;-ms-animation-delay:0.39s;
        }
        div:nth-child(5){
            -webkit-animation-delay:0.52s;
            animation-delay:0.52s;-moz-animation-delay:0.52s;-o-animation-delay:0.52s;-ms-animation-delay:0.52s;
        }
        h3{
            color: #fff;
            font-size: 14px;
        }
    }
}

@-webkit-keyframes load{
    0%,100%{
        height: 25px;
        background: #279FCF;
    }
    50%{
        height: 40px;
        margin-top: -20px;
        background: #fff;
    }
}
@keyframes load{
    0%,100%{
        height: 25px;
        background: #279FCF;
    }
    50%{
        height: 40px;
        margin-top: -20px;
        background: #fff;
    }
}
@-ms-keyframes load{
    0%,100%{
        height: 25px;
        background: #279FCF;
    }
    50%{
        height: 40px;
        margin-top: -20px;
        background: #fff;
    }
}
@-moz-keyframes load{
    0%,100%{
        height: 25px;
        background: #279FCF;
    }
    50%{
        height: 40px;
        margin-top: -20px;
        background: #fff;
    }
}
@-o-keyframes load{
    0%,100%{
        height: 25px;
        background: #279FCF;
    }
    50%{
        height: 40px;
        margin-top: -20px;
        background: #fff;
    }
}
</style>

